import type { UserRole } from '../api';

/**
 * Helpers til at afgøre om den indloggede bruger må udføre forskellige
 * handlinger. Backend håndhæver det samme — det her er bare for at skjule
 * UI-knapper så viewers ikke klikker på noget der bare giver dem en fejl.
 */

/** Må oprette/redigere/slette items, kategorier, lokationer, links og billeder. */
export function canWrite(role: UserRole | undefined | null): boolean {
  if (!role) return false;
  return role === 'owner' || role === 'admin' || role === 'member';
}

/** Må administrere husstanden: omdøb, invitér, fjern medlem. */
export function canManageHousehold(role: UserRole | undefined | null): boolean {
  if (!role) return false;
  return role === 'owner' || role === 'admin';
}

/** Må ændre andres roller (kun owner). */
export function canChangeRoles(role: UserRole | undefined | null): boolean {
  return role === 'owner';
}
